import { render, staticRenderFns } from "./MainTwitch.vue?vue&type=template&id=7750fa18&scoped=true&"
import script from "./MainTwitch.vue?vue&type=script&lang=js&"
export * from "./MainTwitch.vue?vue&type=script&lang=js&"
import style0 from "./MainTwitch.vue?vue&type=style&index=0&id=7750fa18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7750fa18",
  null
  
)

export default component.exports